import { AlertTriangle, Bot } from "lucide-react";
import { addDays, fmtTime, memberColor } from "./agendaUtils";

export default function WeekGrid({ weekStart, events, members, onSelect, onCreateAt }) {
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
  const today = new Date().toDateString();
  return (
    <div className="overflow-x-auto pm-scroll" data-testid="agenda-week-grid">
      <div className="min-w-[980px] grid grid-cols-7 gap-px bg-slate-200 rounded-xl overflow-hidden">
        {days.map((d, i) => {
          const isToday = d.toDateString() === today;
          const dayEvents = events.filter((e) => new Date(e.start).toDateString() === d.toDateString());
          return (
            <div key={i} className={`bg-white p-3 min-h-[260px] flex flex-col ${isToday ? "ring-2 ring-inset ring-emerald-400" : ""}`} data-testid={`agenda-day-${i}`}>
              <div className="flex items-baseline justify-between mb-2">
                <span className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-400">
                  {d.toLocaleDateString("nl-NL", { weekday: "short" })}
                </span>
                <span className={`font-mono-tab text-sm ${isToday ? "text-emerald-700 font-bold" : "text-slate-700"}`}>{d.getDate()}</span>
              </div>
              <div className="space-y-1.5 flex-1">
                {dayEvents.map((e) => {
                  const colour = memberColor(members, e.owner_user_id);
                  const conflict = (e.conflicts_with || []).length > 0;
                  return (
                    <button
                      key={e.id}
                      type="button"
                      onClick={() => onSelect(e)}
                      data-testid={`agenda-event-${e.id}`}
                      className={`w-full text-left rounded-lg px-2 py-1.5 border text-[11px] transition-transform hover:-translate-y-px ${conflict ? "border-red-400 bg-red-50" : ""}`}
                      style={conflict ? undefined : { borderColor: colour + "55", background: colour + "12" }}
                      title={conflict ? `Conflict met ${e.conflicts_with.map((c) => c.owner_name).join(", ")}` : e.title}
                    >
                      <div className="font-bold text-slate-900 truncate flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: colour }} />
                        <span className="truncate">{e.title}</span>
                        {e.source === "ai" && <Bot size={10} className="text-emerald-600 shrink-0" />}
                        {conflict && <AlertTriangle size={10} className="text-red-600 shrink-0" />}
                      </div>
                      <div className="text-slate-500 truncate">
                        {fmtTime(e.start)} · {e.owner_name?.split(" ")[0] || "—"}{e.client_name ? ` · ${e.client_name.split(" ").slice(-1)[0]}` : ""}
                      </div>
                    </button>
                  );
                })}
              </div>
              <button
                type="button"
                onClick={() => onCreateAt(d)}
                className="mt-2 text-[10px] text-slate-400 hover:text-emerald-700 text-left"
                data-testid={`agenda-add-day-${i}`}
              >+ afspraak</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
